// Product image lightbox with prev/next navigation
(function () {
  'use strict';

  var lb, lbImg, lbCounter, lbPrev, lbNext;
  var images = [];
  var idx = 0;

  function build() {
    if (lb) return;
    lb = document.createElement('div');
    lb.id = 'ni-lightbox';
    lb.setAttribute('role', 'dialog');
    lb.setAttribute('aria-modal', 'true');
    lb.setAttribute('aria-label', 'Image viewer');
    lb.style.display = 'none';
    lb.innerHTML =
      '<div class="ni-lb__backdrop"></div>' +
      '<div class="ni-lb__frame">' +
        '<img class="ni-lb__img" src="" alt="" decoding="async">' +
      '</div>' +
      '<button class="ni-lb__nav ni-lb__prev" aria-label="Previous image">&#8249;</button>' +
      '<button class="ni-lb__nav ni-lb__next" aria-label="Next image">&#8250;</button>' +
      '<button class="ni-lb__close" aria-label="Close image viewer">' +
        '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">' +
          '<line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>' +
        '</svg>' +
      '</button>' +
      '<span class="ni-lb__counter"></span>';

    lbImg    = lb.querySelector('.ni-lb__img');
    lbCounter = lb.querySelector('.ni-lb__counter');
    lbPrev   = lb.querySelector('.ni-lb__prev');
    lbNext   = lb.querySelector('.ni-lb__next');

    lb.querySelector('.ni-lb__close').addEventListener('click', close);
    lbPrev.addEventListener('click', function (e) { e.stopPropagation(); go(-1); });
    lbNext.addEventListener('click', function (e) { e.stopPropagation(); go(1); });

    // Close on any click that isn't the image itself or a control button.
    // Delegating on the whole overlay (rather than only the backdrop child)
    // means clicking the empty padding around the image also closes, which
    // is what users expect from "click outside to dismiss".
    lb.addEventListener('click', function (e) {
      if (e.target.closest('.ni-lb__img, .ni-lb__nav, .ni-lb__close')) return;
      close();
    });

    // Swipe support
    var touchStartX = 0;
    lb.addEventListener('touchstart', function (e) { touchStartX = e.touches[0].clientX; }, { passive: true });
    lb.addEventListener('touchend', function (e) {
      var dx = e.changedTouches[0].clientX - touchStartX;
      if (Math.abs(dx) > 50) go(dx < 0 ? 1 : -1);
    }, { passive: true });

    document.addEventListener('keydown', function (e) {
      if (!lb.classList.contains('is-open')) return;
      if (e.key === 'Escape')     close();
      if (e.key === 'ArrowLeft')  go(-1);
      if (e.key === 'ArrowRight') go(1);
    });

    document.body.appendChild(lb);
  }

  function open(startIdx, imgs) {
    build();
    images = imgs;
    idx = startIdx;
    show();
    lb.style.display = 'flex';
    document.body.classList.add('ni-lb-open');
    requestAnimationFrame(function () { lb.classList.add('is-open'); });
  }

  function close() {
    lb.classList.remove('is-open');
    document.body.classList.remove('ni-lb-open');
    setTimeout(function () { if (!lb.classList.contains('is-open')) lb.style.display = ''; }, 260);
  }

  function go(dir) {
    idx = (idx + dir + images.length) % images.length;
    show();
  }

  function show() {
    lbImg.src = images[idx].src;
    lbImg.alt = images[idx].alt || '';
    lbCounter.textContent = images.length > 1 ? (idx + 1) + ' / ' + images.length : '';
    lbPrev.style.visibility = images.length > 1 ? 'visible' : 'hidden';
    lbNext.style.visibility = images.length > 1 ? 'visible' : 'hidden';
  }

  function bestSrc(imgEl) {
    // Liquid can stamp a server-rendered high-resolution URL onto the img.
    // That's the most reliable source for the viewer, because the displayed
    // gallery / list thumbnail is often only a tiny ?width=88 variant.
    var zoom = imgEl.getAttribute('data-zoom-src');
    if (zoom) return zoom;
    var srcset = imgEl.getAttribute('srcset') || '';
    if (srcset) {
      var best = srcset.split(',').map(function (p) { return p.trim().split(/\s+/); })
        .reduce(function (a, b) { return (parseInt(b[1]) || 0) > (parseInt(a[1]) || 0) ? b : a; });
      if (best[0]) return upgradeShopifyWidth(best[0]);
    }
    return upgradeShopifyWidth(imgEl.getAttribute('src') || '');
  }

  // Bump Shopify CDN width to a generous value so the viewer shows detail
  // instead of the thumbnail-sized variant rendered in the gallery.
  function upgradeShopifyWidth(url) {
    if (!url) return url;
    try {
      var u = new URL(url, window.location.origin);
      if (!/cdn\.shopify\.com|shopify\.com\/s\/files/.test(u.hostname + u.pathname)) return url;
      u.searchParams.delete('height');
      u.searchParams.set('width', '2000');
      return u.toString();
    } catch (_) {
      return url;
    }
  }

  // Intercept clicks on niimbot custom PDP galleries (label-maker + refill).
  // These don't use Dawn's .product__modal-opener--image, so they need their
  // own opener. The handler walks every <img> inside the main-image
  // container, starts from whichever is currently `.is-active`, and opens
  // the lightbox with the full list so the customer can flip through every
  // variation / detail shot at high resolution. Works for PC and mobile.
  document.addEventListener('click', function (e) {
    // Only the main image area is a zoom target — thumbnails already have
    // their own click behaviour (swap the main image) and shouldn't open
    // the viewer.
    var wrap = e.target.closest('.nb-buy__main-image, .nb-rbuy__main-image');
    if (!wrap) return;
    // Skip the gallery's own prev/next arrows.
    if (e.target.closest('.nb-buy__nav, .nb-rbuy__nav, button')) return;
    var imgs = Array.from(wrap.querySelectorAll('img'));
    if (!imgs.length) return;
    e.preventDefault();
    var startIdx = 0;
    for (var i = 0; i < imgs.length; i++) {
      if (imgs[i].classList.contains('is-active')) { startIdx = i; break; }
    }
    var list = imgs.map(function (im) { return { src: bestSrc(im), alt: im.alt || '' }; });
    open(startIdx, list);
  });

  // Refill PDP: variations are shown as a list with a small thumbnail in
  // front of each row (.nb-vlist__img). These thumbnails carry per-variation
  // detail the customer needs to read, so make them zoomable too. Clicking a
  // thumbnail opens the lightbox starting on that variation's image, with the
  // full set of variation images so they can flip through all of them.
  document.addEventListener('click', function (e) {
    var cell = e.target.closest('.nb-vlist__img');
    if (!cell) return;
    var vlist = cell.closest('[data-vlist]') || cell.closest('.nb-vlist') || document;
    var imgs = Array.from(vlist.querySelectorAll('.nb-vlist__img img'));
    if (!imgs.length) return;
    e.preventDefault();
    var clicked = cell.querySelector('img');
    var startIdx = Math.max(0, imgs.indexOf(clicked));
    var list = imgs.map(function (im) { return { src: bestSrc(im), alt: im.alt || '' }; });
    open(startIdx, list);
  });

  // Intercept clicks on product gallery images (capture phase, before modal-opener)
  document.addEventListener('click', function (e) {
    var opener = e.target.closest('.product__modal-opener--image');
    if (!opener) return;

    var list = opener.closest('.product__media-list');
    if (!list) return;

    e.preventDefault();
    e.stopImmediatePropagation();

    var items = Array.from(list.querySelectorAll('.product__media-item:not([hidden])'));
    var imgs = [];
    items.forEach(function (item) {
      var imgEl = item.querySelector('img');
      if (imgEl) imgs.push({ src: bestSrc(imgEl), alt: imgEl.alt || '' });
    });
    if (!imgs.length) return;

    var clickedItem = opener.closest('.product__media-item');
    var clickedIdx  = items.indexOf(clickedItem);
    open(Math.max(0, clickedIdx), imgs);
  }, true);
})();
